export interface BlogPostSection {
  heading?: string;
  paragraphs: string[];
}

export interface BlogPost {
  slug: string;
  category: string;
  title: string;
  excerpt: string;
  image: string;
  publishedAt: string;
  sections: BlogPostSection[];
}

export const BLOG_POSTS: BlogPost[] = [
  {
    slug: "kakie-parokonvektomaty-vybrat",
    category: "Тепловое оборудование",
    title: "Какие пароконвектоматы выбрать для ресторана?",
    excerpt:
      "Разбираемся, чем отличаются конвекционные, комбинированные и высокоскоростные пароконвектоматы — и как подобрать вместимость под поток гостей.",
    image: "/assets/products/rational/icombi-pro-xs-6-2-3.jpg",
    publishedAt: "2026-07-20",
    sections: [
      {
        heading: "Зачем ресторану пароконвектомат",
        paragraphs: [
          "Пароконвектомат — один из немногих аппаратов, который способен закрыть сразу несколько задач на кухне: выпечку, тушение, варку на пару, жарку и су-вид в одном корпусе. Для заведения это означает меньше отдельных единиц оборудования, меньше занятой площади и более предсказуемый результат от смены к смене, даже если состав поваров меняется.",
        ],
      },
      {
        heading: "Основные типы пароконвектоматов",
        paragraphs: [
          "Конвекционные модели работают только сухим горячим воздухом — это классика для выпечки и запекания, но без функции пара.",
          "Комбинированные (пароконвекционные) аппараты сочетают пар и конвекцию и позволяют переключаться между режимами или комбинировать их — это самый универсальный и распространённый выбор для ресторанной кухни.",
          "Компактные и высокоскоростные модели рассчитаны на кухни с ограниченной площадью — дарк-китчены, кофейни с кухней, небольшие кафе — где важна скорость выхода блюда при малом количестве загрузок.",
        ],
      },
      {
        heading: "Как подобрать вместимость",
        paragraphs: [
          "Вместимость аппарата считается по количеству и размеру гастроёмкостей (GN), которые он вмещает за одну загрузку — 6×1/1, 10×1/1, 20×1/1 и так далее. Отправная точка — не площадь кухни, а среднее и пиковое число посадок за смену: сколько блюд нужно приготовить одновременно в час пик, и сколько времени занимает один цикл готовки для основных позиций меню.",
        ],
      },
      {
        heading: "На что обратить внимание при выборе",
        paragraphs: [
          "Автоматические программы приготовления снижают требования к квалификации персонала и стабилизируют качество блюда независимо от того, кто стоит у плиты.",
          "Система самоочистки экономит время закрытия смены и продлевает срок службы камеры.",
          "Тип энергоснабжения (электро или газ) стоит определять исходя из имеющейся подведённой мощности на объекте — переход с одного типа на другой на этапе ремонта обходится дороже, чем правильный выбор на старте.",
        ],
      },
      {
        paragraphs: [
          "Мы подбираем модель и комплектацию пароконвектомата под конкретный проект — с учётом меню, потока гостей и уже существующих инженерных сетей объекта. Если нужна консультация, оставьте заявку — наши инженеры предложат решение и подготовят коммерческое предложение.",
        ],
      },
    ],
  },
  {
    slug: "kak-vybrat-posudomoechnuyu-tehniku",
    category: "Посудомоечное оборудование",
    title: "Как выбрать посудомоечную технику для вашего заведения",
    excerpt:
      "Фронтальные, купольные или туннельные машины — рассказываем, какой тип посудомоечного оборудования подходит для кафе, ресторана или фабрики-кухни.",
    image: "/assets/products/electrolux/400301.jpg",
    publishedAt: "2026-07-22",
    sections: [
      {
        heading: "Почему тип машины имеет значение",
        paragraphs: [
          "Посудомоечное оборудование редко выбирают по паспортным характеристикам в отрыве от формата заведения — а зря. Машина, отлично работающая в кофейне на 20 посадок, просто не успеет обслужить поток отеля или фабрики-кухни, и наоборот — избыточно мощное оборудование в небольшом заведении окажется просто нерентабельным.",
        ],
      },
      {
        heading: "Основные типы посудомоечных машин",
        paragraphs: [
          "Фронтальные машины — компактное решение для кафе, баров и небольших ресторанов с невысоким и равномерным потоком посуды в течение дня.",
          "Купольные машины рассчитаны на средний и высокий поток — стандартный выбор для ресторана полного цикла с плотной посадкой в часы пик.",
          "Туннельные (конвейерные) машины проектируются под непрерывную и высокую нагрузку — отели, комбинаты питания, фабрики-кухни и кейтеринг, где посуда идёт потоком в течение всей смены.",
        ],
      },
      {
        heading: "Как рассчитать нужную производительность",
        paragraphs: [
          "Отправная точка — не общее количество посадочных мест, а пиковая нагрузка: сколько корзин или единиц посуды нужно вымыть за час в самый загруженный отрезок смены, и сколько времени есть на один цикл мойки без потери оборота стола.",
        ],
      },
      {
        heading: "Дополнительные факторы",
        paragraphs: [
          "Расход воды и энергии напрямую влияет на операционные расходы — особенно при высокой сменности использования.",
          "Система водоподготовки (умягчение воды) защищает нагревательные элементы от накипи и продлевает срок службы машины, особенно в регионах с жёсткой водой.",
          "Опция сушки и соответствие санитарным нормам стоит уточнять отдельно для заведений с собственными требованиями СЭС или сетевыми стандартами.",
        ],
      },
      {
        paragraphs: [
          "Barcraft подбирает посудомоечное оборудование под фактический поток посуды на объекте, а не по общим рекомендациям производителя — это позволяет не переплачивать за избыточную мощность и не упереться в потолок производительности через полгода после открытия.",
        ],
      },
    ],
  },
  {
    slug: "holodilnoe-oborudovanie-dlya-kuhni-restorana",
    category: "Холодильное оборудование",
    title: "Холодильное оборудование для кухни ресторана: как не ошибиться с выбором",
    excerpt:
      "От шкафов шоковой заморозки до охлаждаемых столов — разбираем, какое холодильное оборудование действительно нужно профессиональной кухне.",
    image: "/assets/products/nilma/fastercold-1.jpg",
    publishedAt: "2026-07-25",
    sections: [
      {
        heading: "Холодильная цепочка на профессиональной кухне",
        paragraphs: [
          "Разрыв холодильной цепи — одна из самых частых причин списаний и претензий по качеству блюд. Продукт должен оставаться в нужном температурном диапазоне на каждом этапе: от приёмки и хранения до подготовки к подаче — и под каждый из этих этапов подбирается своё оборудование.",
        ],
      },
      {
        heading: "Основные категории оборудования",
        paragraphs: [
          "Холодильные шкафы — база для хранения запасов продукции, подбираются по объёму и температурному режиму (среднетемпературные или низкотемпературные).",
          "Охлаждаемые столы совмещают рабочую поверхность и холодильную камеру прямо под ней — сокращают лишние перемещения повара и ускоряют сборку блюда в часы пик.",
          "Шкафы шоковой заморозки быстро проводят продукт через опасный температурный диапазон и значительно продлевают срок хранения без потери качества — обязательный элемент кухни, работающей по стандартам HACCP.",
          "Льдогенераторы закрывают отдельную, но не менее важную задачу — стабильное количество льда для бара и напитков в течение всей смены.",
        ],
      },
      {
        heading: "На что смотреть при выборе",
        paragraphs: [
          "Объём и занимаемая площадь должны соответствовать не только текущему меню, но и запасу на рост оборота — расширение холодильной зоны после запуска почти всегда сложнее и дороже, чем закладка резерва на старте.",
          "Тип хладагента стоит уточнять отдельно: современные экологичные хладагенты (например, R290) постепенно становятся стандартом и влияют на энергоэффективность оборудования.",
          "Односекционные модели с одной температурной зоной проще и дешевле, но двухзонные шкафы и столы дают больше гибкости, если меню сочетает продукты с разными требованиями к хранению.",
        ],
      },
      {
        paragraphs: [
          "Мы помогаем спроектировать холодильную зону кухни целиком — от приёмки до линии раздачи — с учётом реального меню и потока гостей, а не только по каталожным характеристикам отдельных единиц оборудования.",
        ],
      },
    ],
  },
];

export function getBlogPostBySlug(slug: string): BlogPost | undefined {
  return BLOG_POSTS.find((post) => post.slug === slug);
}
